import React from 'react';
import SimulationApprovalUI from '../SimulationApprovalUI';

interface InterruptDisplayProps {
  content: string;
  onInterruptResponse?: (responseType: string, responseData?: any, interruptId?: string, chatId?: string | number, messageId?: number) => void;
  hasActiveSession?: boolean;
  isLoading?: boolean;
  showBigChatBox?: boolean;
}

const InterruptDisplay: React.FC<InterruptDisplayProps> = ({ 
  content, 
  onInterruptResponse, 
  hasActiveSession = false, 
  isLoading = false,
  showBigChatBox = false
}) => {
  // Parse the interrupt JSON content
  let interruptData;

  try {
    // Extract JSON from <interrupt>...</interrupt> tags
    const jsonMatch = content.match(/<interrupt>([\s\S]*?)<\/interrupt>/);
    let jsonString = jsonMatch ? jsonMatch[1] : content;
    
    // Use eval to parse Python-style dictionary (safer than manual replacement)
    // This handles complex nested quotes in HTML content
    try {
      // Replace Python literals
      const pythonToJs = jsonString
        .replace(/True/g, 'true')
        .replace(/False/g, 'false')
        .replace(/None/g, 'null');
      
      // Use eval to safely parse Python dictionary syntax
      interruptData = eval(`(${pythonToJs})`);
    } catch (evalError) {
      // Fallback: try simple quote replacement
      const fallbackString = jsonString.replace(/'/g, '"');
      interruptData = JSON.parse(fallbackString);
    }
  } catch (error) {
    // If parsing fails completely, don't show anything
    return null;
  }

  // Use the actual InterruptUI components
  switch (interruptData.type) {
    case 'simulation_approval_ui':
      return (
        <div>
          <SimulationApprovalUI
            interruptId={interruptData.interrupt_id}
            workItemId={interruptData.work_item_id}
            plan={interruptData.plan || []}
            message={interruptData.message || 'Please review this simulation plan:'}
            onApprove={() => onInterruptResponse?.('approve', {}, interruptData.interrupt_id, interruptData.chat_id, interruptData.message_id)}
            onModify={(modifications) => onInterruptResponse?.('modify', modifications, interruptData.interrupt_id, interruptData.chat_id, interruptData.message_id)}
            onCancel={() => onInterruptResponse?.('cancel', {}, interruptData.interrupt_id, interruptData.chat_id, interruptData.message_id)}
            loading={isLoading}
            showBigChatBox={showBigChatBox}
            readOnly={true}
          />
        </div>
      );
    case 'question_ui':
      return null;
    default:
      return null; // Don't show unknown interrupt types in timeline
  }
};

export default InterruptDisplay;

